'use client';

import { type ReactNode, useRef, useState } from 'react';

import { FirstClickedVideoContext } from '@/app_lib/hooks/useFirstClickedVideo';

export const FirstClickedVideoProvider = ({ children }: { children: ReactNode }) => {
  const [firstClickedVideoId, setFirstClickedVideoIdState] = useState<string | null>(null);
  const lockedRef = useRef(false);

  const setFirstClickedVideoId = (id: string) => {
    if (lockedRef.current) {
      return;
    }
    lockedRef.current = true;
    setFirstClickedVideoIdState(id);
  };

  return (
    <FirstClickedVideoContext.Provider value={{ firstClickedVideoId, setFirstClickedVideoId }}>
      {children}
    </FirstClickedVideoContext.Provider>
  );
};
